import React, {Component} from "react"
import {isEmpty} from "lodash"

import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import RewardOrdersQuery, {RewardOrdersQueryResult} from "@irati/reward/apollo/query/RewardOrders"
import authentication from "@irati/auth"
import {H4} from "@irati/ui/src//Typography/Heading"
import {ReactTable} from "@irati/ui/src/Table"
import Loading from "@irati/ui/src/Loading"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import {ReportType} from "@irati/types"

import Flex from "@irati/ui/src/Flex"
import {StyledCard} from "../../../containers/Reporting/styled"
import {HeaderWrapper, StyledTooltip, Error} from "../styled/styled"
import columns from "./columns/index"

const LIMIT = 5

interface Props extends InjectIntl {}

interface State {
  page: number,
  csvLoad: Promise<any> | null
}

class RewardOrders extends Component<InjectIntl, State, Props> {
  state = {
    page: 0,
    csvLoad: null
  }

  handlePageChange = (nextPage: number) => {
    this.setState({page: nextPage})
  }

  handleCSVDownload = () => {
    const csvLoad = adminReportingService.getRewardsReportUrl(authentication.business().uuid, ReportType.RewardTransactions)
      .then(({reportFileUrl}) => {
        const fileName = "reward-log.csv"
        const link = document.createElement("a")
        link.setAttribute("href", reportFileUrl)
        link.setAttribute("download", fileName)
        link.style.visibility = "hidden"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    this.setState({csvLoad})
  }

  removeUnpopulatedUsers = (rewardOrders) => {
    return rewardOrders.results
      .map((reward) => {
        return {
          ...reward,
          recipients: {
            results: reward.recipients.results.filter((user) => user)
          }
        }
      })
  }

  render() {
    const {formatMessage} = this.props.intl

    const {page, csvLoad} = this.state
    const variables = {
      limit: LIMIT,
      offset: page * LIMIT,
      tenantId: authentication.business().uuid,
      partialRewardOrders: true
    }

    return (
      <StyledCard>
        <RewardOrdersQuery variables={variables}>
          {({data: {rewardOrders}}: RewardOrdersQueryResult) => {
            const total = isEmpty(rewardOrders) ? 0 : rewardOrders.count
            const pages = Math.ceil(total / LIMIT)

            if (!rewardOrders?.results?.length) {
              return (
                <Error>
                  <FormattedMessage id="admin.reporting.error.empty" />
                </Error>
              )
            }

            console.log("paggination")

            return (
              <>
                <HeaderWrapper>
                  <Flex alignItems="center">
                    <H4 bold>
                      <FormattedMessage id="admin.reporting.rewardOrders.heading" />
                    </H4>
                    <StyledTooltip>
                      <FormattedMessage id="admin.reporting.rewardOrders.para" />
                    </StyledTooltip>
                  </Flex>
                  <Button id="exportRewardLogDownload_button" tertiary onClick={this.handleCSVDownload} load={csvLoad}>
                    <FormattedMessage id="admin.reporting.rewardLog.download" />
                    <Icon icon={IconTypes.downloadReport} marginLeft />
                  </Button>
                </HeaderWrapper>
                <Loading>
                  <ReactTable
                    getPaginationProps={(allProps: any) => ({
                      ...allProps,
                      shouldScrollOnUpdate: false
                    })}
                    page={page}
                    pages={pages}
                    onPageChange={this.handlePageChange}
                    showPagination
                    defaultPageSize={LIMIT}
                    data={rewardOrders.results}
                    columns={columns(formatMessage)} />
                </Loading>
              </>
            )
          }}
        </RewardOrdersQuery>
      </StyledCard>
    )
  }
}

export default injectIntl(RewardOrders)
